import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { FaMapMarkerAlt } from "react-icons/fa";
import logo from "../../../assets/logo.png";
import { API_BASE_URL } from "../../../config";

export default function CleaningBusinessListings() {
  const [listings, setListings] = useState([]);
  const [filters, setFilters] = useState({ state: "" });



  const options = {
    state: ["NSW", "VIC", "QLD", "SA", "WA", "TAS", "NT", "ACT"],
  };

  // ============================
  // FETCH BUSINESS LISTINGS
  // ============================
  useEffect(() => {
    fetch(`${API_BASE_URL}/api/cleaning/business`)
      .then((res) => res.json())
      .then((data) => {
        if (data.success) setListings(data.listings);
      })
      .catch((err) =>
        console.error("❌ Failed to load cleaning businesses:", err)
      );
}, [API_BASE_URL]);

  const filteredListings = listings.filter(
    (l) => !filters.state || l.state === filters.state
  );

  const cardStyle = {
    backgroundColor: "#fff",
    borderRadius: "12px",
    boxShadow: "0 2px 6px rgba(0,0,0,0.1)",
    overflow: "hidden",
    transition: "transform 0.2s ease",
  };

  const viewButton = {
    width: "100%",
    marginTop: "8px",
    backgroundColor: "#2e7d32",
    color: "#fff",
    padding: "10px",
    border: "none",
    borderRadius: "6px",
    cursor: "pointer",
    fontWeight: "bold",
  };

  const buttonStyle = {
    width: "100%",
    padding: "12px",
    backgroundColor: "#2e7d32",
    color: "#fff",
    border: "none",
    borderRadius: "8px",
    cursor: "pointer",
    fontWeight: "bold",
    marginBottom: "10px",
  };

  return (
    <div style={{ display: "flex", minHeight: "100vh", background: "#f4f7f9" }}>
      {/* SIDEBAR */}
      <aside
        style={{
          width: "250px",
          backgroundColor: "#2e7d32",
          color: "#fff",
          padding: "20px",
          position: "sticky",
          top: 0,
          height: "100vh",
          textAlign: "center",
        }}
      >
        <img src={logo} alt="Client Exchange" style={{ width: "140px", marginBottom: "25px" }} />

        <h3>Filters</h3>

        <label>State</label>
        <select
          value={filters.state}
          onChange={(e) => setFilters({ state: e.target.value })}
          style={{ width: "100%", padding: "10px", borderRadius: "6px" }}
        >
          <option value="">All</option>
          {options.state.map((s) => (
            <option key={s} value={s}>{s}</option>
          ))}
        </select>

        <button
          onClick={() => setFilters({ state: "" })}
          style={{ ...buttonStyle, backgroundColor: "#d32f2f", marginTop: "15px" }}
        >
          Reset Filters
        </button>
      </aside>

      {/* GRID */}
      <main style={{ flex: 1, padding: "20px" }}>
        <h2 style={{ color: "#2e7d32", marginBottom: "15px" }}>
          Cleaning Businesses — {filteredListings.length} Results
        </h2>

        <div style={{ display: "grid", gridTemplateColumns: "repeat(2, 1fr)", gap: "20px" }}>
          {filteredListings.map((listing) => (
            <div key={listing.id} style={cardStyle}>
              <img
                src="/images/Cleaning.jpg"
                alt="Cleaning Business"
                style={{ width: "100%", height: "200px", objectFit: "cover" }}
              />

              <div style={{ padding: "15px" }}>
                <h3>{listing.business_title}</h3>

                <p>ID: <strong>BUS-{listing.id}</strong></p>

                <div style={{ color: "#2e7d32", fontWeight: "bold" }}>
                  Asking Price: ${Number(listing.price).toLocaleString()}
                </div>

                <p style={{ marginTop: "6px" }}>
                  <FaMapMarkerAlt /> {listing.suburb}, {listing.state}
                </p>

                <Link to={`/cleaning/business/${listing.id}`}>
                  <button style={viewButton}>View Details</button>
                </Link>
              </div>
            </div>
          ))}
        </div>
      </main>
    </div>
  );
}
